// extracted by mini-css-extract-plugin
export var blue = "_42-f";
export var brand = "_42-b";
export var darkGrey = "_42-e";
export var disabled = "_42-4";
export var disabledSubtle = "_42-5";
export var error = "_42-6";
export var green = "_42-g";
export var grey = "_42-d";
export var icon = "_42-0";
export var inherit = "_42-a";
export var lightGrey = "_42-c";
export var orange = "_42-i";
export var pink = "_42-k";
export var primary = "_42-1";
export var purple = "_42-l";
export var red = "_42-j";
export var secondary = "_42-2";
export var success = "_42-9";
export var tertiary = "_42-3";
export var warning = "_42-7";
export var warningSecondary = "_42-8";
export var white = "_42-m";
export var yellow = "_42-h";